"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Backdrop = _interopRequireDefault(require("@material-ui/core/Backdrop"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _header = _interopRequireDefault(require("./header"));

var _googleMap = _interopRequireDefault(require("./googleMap"));

var _filters = _interopRequireDefault(require("./filters"));

var _details = _interopRequireDefault(require("./details"));

var _sponsors = _interopRequireDefault(require("./sponsors"));

var _fullScreen = _interopRequireDefault(require("../_common/dialog/fullScreen"));

var _welcomeDialog = _interopRequireDefault(require("../locator/welcomeDialog"));

var _actions = require("../../redux/locations/actions");

var _actions2 = require("../../redux/attributes/actions");

var _selectors = require("../../redux/locations/selectors");

var _selectors2 = require("../../redux/login/selectors");

var _actions3 = require("../../redux/login/actions");

var _nicaLocatorCore = require("../nicaLocatorCore");

var _dialog = _interopRequireDefault(require("./filters/dialog"));

var _mobile = _interopRequireDefault(require("./googleMap/mobile"));

var _searchResults = _interopRequireDefault(require("./searchResults"));

var _countryBlockedDialog = _interopRequireDefault(require("./countryBlockedDialog"));

var _blacklistDialog = _interopRequireDefault(require("./blacklistDialog"));

var _rateLimitDialog = _interopRequireDefault(require("./rateLimitDialog"));

var _icFilter = _interopRequireDefault(require("../../img/ic-filter.svg"));

var _icSpinner = _interopRequireDefault(require("../../img/ic-spinner.svg"));

require("./index.css");

var _tos = _interopRequireDefault(require("./survey/tos"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Locator = function Locator() {
  var _useState = (0, _react.useState)(-1),
      _useState2 = _slicedToArray(_useState, 2),
      focusedId = _useState2[0],
      setFocusedId = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      focusedIndex = _useState4[0],
      setFocusedIndex = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showFilters = _useState6[0],
      setShowFilters = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showTos = _useState8[0],
      setShowTos = _useState8[1];

  var _useSearchSelector = (0, _selectors.useSearchSelector)(),
      searchRadius = _useSearchSelector.searchRadius,
      filter = _useSearchSelector.filter,
      lastSearchQuery = _useSearchSelector.lastSearchQuery;

  var dispatch = (0, _reactRedux.useDispatch)();
  var history = (0, _reactRouterDom.useHistory)();

  var _useParams = (0, _reactRouterDom.useParams)(),
      locationId = _useParams.locationId;

  var _useLoginSelector = (0, _selectors2.useLoginSelector)(),
      claims = _useLoginSelector.claims,
      loggedIn = _useLoginSelector.loggedIn,
      authEmail = _useLoginSelector.authEmail,
      initialBlacklistMessage = _useLoginSelector.initialBlacklistMessage,
      userIP = _useLoginSelector.userIP,
      blockCountry = _useLoginSelector.blockCountry,
      isBlacklisted = _useLoginSelector.isBlacklisted,
      remainingSearches = _useLoginSelector.remainingSearches;

  var _useContext = (0, _react.useContext)(_nicaLocatorCore.AppContext),
      _useContext$component = _useContext.components,
      FiltersComponent = _useContext$component.FiltersComponent,
      FooterComponent = _useContext$component.FooterComponent,
      TopNavComponent = _useContext$component.TopNavComponent,
      _useContext$flags = _useContext.flags,
      hideSponsors = _useContext$flags.hideSponsors,
      hideGoToAdmin = _useContext$flags.hideGoToAdmin,
      hideFilters = _useContext$flags.hideFilters,
      hideWelcomeDialog = _useContext$flags.hideWelcomeDialog;

  (0, _react.useEffect)(function () {
    if (userIP && !blockCountry && !isBlacklisted) {
      dispatch((0, _actions.initialSearch)(lastSearchQuery, searchRadius, filter));
      dispatch((0, _actions2.loadAttributes)());
    }
  }, [userIP, blockCountry, isBlacklisted]); // eslint-disable-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function () {
    if (authEmail) {
      dispatch((0, _actions3.signInWithEmailLink)(authEmail));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var goBack = function goBack() {
    return history.goBack();
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "h-full flex flex-col"
  }, TopNavComponent && /*#__PURE__*/_react.default.createElement(TopNavComponent, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-container flex flex1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-form flex column"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-header"
  }, /*#__PURE__*/_react.default.createElement(_header.default, null)), !hideFilters && /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    smUp: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-form-filters-placeholder",
    onClick: function onClick() {
      return setShowFilters(true);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _icFilter.default,
    alt: "filter"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 headlineFont marginLeft15"
  }, "Filters"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _icSpinner.default,
    alt: "spinner"
  }))))), /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 scrollY"
  }, !hideFilters && (FiltersComponent ? /*#__PURE__*/_react.default.createElement(FiltersComponent, null) : /*#__PURE__*/_react.default.createElement(_filters.default, null)), /*#__PURE__*/_react.default.createElement(_searchResults.default, {
    setFocusedId: setFocusedId
  })))), !hideSponsors && /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement("div", null, FooterComponent ? /*#__PURE__*/_react.default.createElement(FooterComponent, null) : /*#__PURE__*/_react.default.createElement(_sponsors.default, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-map relative flex1 flex flex-col"
  }, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    smUp: true
  }, /*#__PURE__*/_react.default.createElement(_mobile.default, {
    currentIndex: focusedIndex
  })), /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-1 relative"
  }, /*#__PURE__*/_react.default.createElement(_googleMap.default, {
    focusedId: focusedId
  })), claims && loggedIn && !hideGoToAdmin && /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-admin-button"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return window.open("https://admin.infusioncenter.org", "target=_blank");
    }
  }, "Go to location manager & store")))), /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    smUp: true
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-mobile-results"
  }, /*#__PURE__*/_react.default.createElement(_searchResults.default, {
    setFocusedId: setFocusedId,
    setFocusedIndex: setFocusedIndex
  })), !hideSponsors && /*#__PURE__*/_react.default.createElement("div", null, FooterComponent ? /*#__PURE__*/_react.default.createElement(FooterComponent, null) : /*#__PURE__*/_react.default.createElement(_sponsors.default, {
    label: ""
  })))), /*#__PURE__*/_react.default.createElement(_Backdrop.default, {
    open: !userIP,
    className: "locator-backdrop"
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: 45,
    color: "inherit"
  })), /*#__PURE__*/_react.default.createElement(_fullScreen.default, {
    onClose: goBack,
    open: Boolean(locationId)
  }, /*#__PURE__*/_react.default.createElement(_details.default, null)), /*#__PURE__*/_react.default.createElement(_dialog.default, {
    open: showFilters,
    onClose: function onClose() {
      return setShowFilters(false);
    }
  }), /*#__PURE__*/_react.default.createElement(_rateLimitDialog.default, {
    open: remainingSearches === 0
  }), /*#__PURE__*/_react.default.createElement(_blacklistDialog.default, {
    open: Boolean(isBlacklisted),
    initialBlacklistMessage: initialBlacklistMessage
  }), /*#__PURE__*/_react.default.createElement(_countryBlockedDialog.default, {
    open: Boolean(blockCountry)
  }), !hideWelcomeDialog && /*#__PURE__*/_react.default.createElement(_welcomeDialog.default, {
    setShowTos: setShowTos
  }), /*#__PURE__*/_react.default.createElement(_tos.default, {
    open: showTos,
    onClose: function onClose() {
      return setShowTos(false);
    }
  })));
};

var _default = Locator;
exports.default = _default;